import apiWorker from '../apiWorker'

const case_feed = {

    create:   (case_id, data) => apiWorker('post',  `/api/v1/core/case_feed/create/${case_id}`, data),

}

export default case_feed;